<script>
	import { Router, Link, link, Route } from "svelte-routing";

	const promotions = [
		{
			key: 'CARENCIA',
			title: 'Carência',
			image: 'seloCarencia.png',
			link: '/promocoes'
		},
		{
			key: 'DESCONTO',
			title: 'Desconto',
			image: 'seloDesconto.png',
			link: '/promocoes'
		},
		{
			key: 'OFERTA',
			title: 'Oferta',
			image: 'seloOferta.png',
			link: '/promocoes'
		},
		{
			key: 'NOVIDADE',
			title: 'Novidade',
			image: 'seloNovidade.png',
			link: '/promocoes'
		},
		{
			key: 'MES',
			title: 'Oferta do Mês',
			image: 'seloMes.png',
			link: '/promocoes'
		},
	];

	export let realty = null;
	let promotion = null;
	if (realty != null && realty.Promotion != null) {
		promotion = promotions.find(p => p.key.toUpperCase() == realty.Promotion.toUpperCase());

		//Se começar com número, usa a promo MES
		if (promotion == null && /^\d+$/.test(realty.Promotion.substr(0,1))) {
			promotion = promotions.find(p => p.key == 'MES');
		}
	}
</script>

{#if promotion != null}
<div class="selos">
	{#if promotion.link != null}
	<a class="selo" href="{promotion.link}" use:link replace target="_self">
		<img src="/assets/images/selos/{promotion.image}" border="0" alt={promotion.title} />
	</a>
	{:else}
		<img class="selo" src="/assets/images/selos/{promotion.image}" border="0" alt={promotion.title} />
	{/if}
</div>
{:else}
{/if}

<style type="text/sass">

.selos
	position: absolute
	top: 15px
	left: 12px
	img
		max-width: 101px
</style>